/** Available types of taken subdomain */
export enum TakenSubdomainTypeEnum {
  /** Tenant main subdomain */
  MAIN = 'MAIN',
  /** Tenant alias (old) subdomain */
  ALIAS = 'ALIAS',
  /** Client's personal account subdomain */
  PERSONAL_ACCOUNT = 'PERSONAL_ACCOUNT',
  /** Client's personal account alias (old) subdomain */
  PERSONAL_ACCOUNT_ALIAS = 'PERSONAL_ACCOUNT_ALIAS',
}
